
import DataMapper from '../DataMapper'
import HospitalInfraInvestigatorRM from '../../responsemodel/ReportRM/HospitalInfraInvestigatorRM'
import AttendentInvestigator from '../../../models/ReportModels/AttendentInvestigator'

export default class AttendentInvestigatorDataMapper extends DataMapper<HospitalInfraInvestigatorRM, AttendentInvestigator> {
    map = (rm: HospitalInfraInvestigatorRM) => new AttendentInvestigator(rm._id, rm.claim_number, rm.modified_on, rm.name)
}
